import { render, staticRenderFns } from "./TimeField.vue?vue&type=template&id=bfcdd54a&scoped=true&"
import script from "./TimeField.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TimeField.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TimeField.vue?vue&type=style&index=0&id=bfcdd54a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcdd54a",
  null
  
)

export default component.exports